/**
 * INDICADORES — 6 cards do topo
 * Fonte: /api/laudos/listar.php + /api/vistorias/listar.php
 */
import React, { useEffect, useState } from 'react';
import { FileText, AlertTriangle, Bell, MapPin, Flag, CheckCircle2 } from 'lucide-react';

export default function IndicadoresCards() {
  const [laudos, setLaudos]       = useState([]);
  const [vistorias, setVistorias] = useState([]);
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    Promise.all([
      fetch('/api/laudos/listar.php',    { credentials: 'include' }).then(r => r.json()).catch(() => ({})),
      fetch('/api/vistorias/listar.php', { credentials: 'include' }).then(r => r.json()).catch(() => ({}))
    ]).then(([l, v]) => {
      setLaudos(l.laudos || []);
      setVistorias(v.vistorias || []);
    }).finally(() => setLoading(false));
  }, []);

  const total         = laudos.length;
  const emAndamento   = laudos.filter(l => l.status !== 'CONCLUIDO' && l.status !== 'ENCERRADO').length;
  const concluidos    = laudos.filter(l => l.status === 'CONCLUIDO' || l.status === 'ENCERRADO').length;
  const vistProximas  = vistorias.filter(v => v.data_agendada && v.status !== 'CONCLUIDA').length;
  const atrasados     = 0; // regra de negócio futura
  const acao          = emAndamento; // provisório
  const pendencias    = 0; // regra de negócio futura

  const cards = [
    { label: 'Laudos',      valor: total,        icone: FileText,     cor: 'blue'    },
    { label: 'Atrasados',   valor: atrasados,    icone: AlertTriangle,cor: 'red'     },
    { label: 'Ação',        valor: acao,         icone: Bell,         cor: 'amber'   },
    { label: 'Vistorias',   valor: vistProximas, icone: MapPin,       cor: 'cyan'    },
    { label: 'Pendências',  valor: pendencias,   icone: Flag,         cor: 'orange'  },
    { label: 'Concluídos',  valor: concluidos,   icone: CheckCircle2, cor: 'emerald' },
  ];

  const cores = {
    blue:    'text-blue-400 bg-blue-500/[0.08] border-blue-500/20',
    red:     'text-red-400 bg-red-500/[0.08] border-red-500/20',
    amber:   'text-amber-400 bg-amber-500/[0.08] border-amber-500/20',
    cyan:    'text-cyan-400 bg-cyan-500/[0.08] border-cyan-500/20',
    orange:  'text-orange-400 bg-orange-500/[0.08] border-orange-500/20',
    emerald: 'text-emerald-400 bg-emerald-500/[0.08] border-emerald-500/20',
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
      {cards.map((c, i) => {
        const Icone = c.icone;
        return (
          <div key={i} className={`rounded-2xl border p-4 ${cores[c.cor]}`}>
            <div className="flex items-center justify-between mb-3">
              <Icone size={16} />
              <span className="text-[9px] font-bold uppercase tracking-widest opacity-70">
                {c.label}
              </span>
            </div>
            <p className="text-2xl font-black text-white leading-none">
              {loading ? '—' : c.valor}
            </p>
          </div>
        );
      })}
    </div>
  );
}